import { TRANSCRIPT_API } from "../helpers/api-path";
import httpClient from "./http.interceptor";

const generateTranscriptAPI = async (conversationId) => {
    return await httpClient.get(TRANSCRIPT_API, {
        params: {
            id: conversationId,
            environment: process.env.REACT_APP_ENVIRONMENT,
        }
    });
}

export {
    generateTranscriptAPI
}